import React from "react";
import {createRoot} from "react-dom/client";
import {BrowserRouter} from "react-router-dom";
import {Auth0ProviderWithNavigate} from "./auth0";
import {DevAuthProvider} from "./authDev";
import "./i18n/i18n";

// Theming
import {CssBaseline} from "@mui/material";
import {ThemeProvider} from "@mui/material/styles";
import theme from "./theme";
import "./index.css";

// MUI DatePicker Localization
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";

// App component
import App from "./App";
import {RecoilRoot} from "recoil";

const container = document.getElementById("root");
const root = createRoot(container);

// REACT_APP_SKIP_AUTH is a local-only dev flag: when set, the app renders
// with a fake "already logged in" auth state instead of the real Auth0
// login flow. See src/authDev.js. Never set in a deployed build.
const AuthProvider = process.env.REACT_APP_SKIP_AUTH ? DevAuthProvider : Auth0ProviderWithNavigate;

root.render(
  <React.StrictMode>
    <RecoilRoot>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <BrowserRouter>
            <AuthProvider>
              <CssBaseline />
              <App />
            </AuthProvider>
          </BrowserRouter>
        </LocalizationProvider>
      </ThemeProvider>
    </RecoilRoot>
  </React.StrictMode>,
);
